import { LevelGranulometry } from '../../LevelGranulometry';
import { CaseGranulometry } from '../../../cases/CaseGranulometry';

export const isLowestBasementLevel = (
  level: LevelGranulometry,
  caseObj: CaseGranulometry
): boolean => level.level === caseObj.levels[caseObj.levels.length - 2].level;
